import React from 'react';
import { Button } from '../components/ui';

function LeaguePage({ user, setPage, leagueId, leagueName, view }) {
    return (
        <div className="league-page" style={{ 
            padding: '20px',
            paddingTop: '60px' // Account for back button
        }}>
            <h1>League Overview</h1>
            <div style={{ marginBottom: '20px', color: '#666' }}>
                <p><strong>League:</strong> {leagueName || 'No league'}</p>
                {view && <p><strong>View:</strong> {view}</p>}
            </div>
            
            {view === 'matchup' && (
                <div style={{ marginBottom: '30px' }}>
                    <h3>Matchup View</h3>
                    <p>This will show head-to-head matchup information</p>
                </div>
            )}
            
            <div>
                <Button
                    variant="primary"
                    onClick={() => setPage(1)}
                    style={{ marginBottom: '10px' }}
                >
                    Back to Team
                </Button>
            </div>
        </div>
    );
}

export default LeaguePage;